export type TIntegrationsType =
  | "showInfoMerchantModal"
  | "showDeleteModal"
  | "showDisableModal"
  | "showCancelModal";

export type TIntegrationsAction =
  | { type: "showInfoMerchantModal"; open: boolean }
  | { type: "showDeleteModal"; open: boolean }
  | { type: "showDisableModal"; open: boolean }
  | { type: "showCancelModal"; open: boolean };

export interface IIntegrationsModalState {
  showInfoMerchantModal: boolean;
  showDeleteModal: boolean;
  showDisableModal: boolean;
  showCancelModal: boolean;
}

const modalTypes = [
  "showInfoMerchantModal",
  "showDeleteModal",
  "showDisableModal",
  "showCancelModal",
];

export const integrationsModalReducer = (
  state: IIntegrationsModalState,
  action: TIntegrationsAction
): IIntegrationsModalState =>
  modalTypes.includes(action.type)
    ? { ...state, [action.type]: action.open }
    : state;
